import React from 'react';
import '../styles/RoleBadge.css';

const RoleBadge = ({ role }) => {
  const badgeClass = {
    1: 'badge-user',
    5: 'badge-admin',
    9: 'badge-superadmin'
  }[Number(role)] || 'badge-unknown';

  const label = {
    1: '利用者',
    5: '事業所',
    9: 'アドミン'
  }[Number(role)] || '不明';

  return <span className={`role-badge ${badgeClass}`}>{label}</span>;
};

export default RoleBadge;
